import React from "react";

const Placements = () => {
  return (
    <div style={{ marginTop: "80px", marginBottom: "20px" }}>
      <h1>Placements</h1>
    </div>
  );
};

export default Placements;
